import classNames from 'classnames';
import React, { useMemo } from 'react';
import './style.scss';

export interface ProgressBarProps {
    steps: Array<{ title: React.ReactNode }>;
    selectedIndex: number;
    className?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ steps, selectedIndex = 1, className }) => {
    const curIndex = selectedIndex ? (selectedIndex > steps.length ? steps.length : selectedIndex) : 1;

    const ratio = useMemo(() => {
        const stepLen = steps.length;
        const isFirst = curIndex === 1,
            isLast = curIndex === stepLen;
        const perPercent = 1 / stepLen;

        let tmp = (curIndex - 1) * perPercent + perPercent / 2;

        if (isFirst) {
            tmp = 0.1;
        }

        if (isLast) {
            tmp = 1;
        }

        return Number(tmp.toFixed(2));
    }, [steps, curIndex]);

    return (
        <div className={classNames('comp-progress-bar', className)}>
            <div className="content">
                {steps.map((it, index) => {
                    return (
                        <div
                            className={classNames('bar-item', {
                                active: curIndex >= index + 1,
                                selected: curIndex === index + 1
                            })}
                            key={index}>
                            {it.title}
                        </div>
                    );
                })}
            </div>
            <div className="bar" style={{ width: `${ratio * 100}%` }} />
        </div>
    );
};

export default ProgressBar;
